/* unplugin-vue-components disabled */import { render } from "./NotificationList.vue?vue&type=template&id=dcf46392&scoped=true&ts=true"
import script from "./NotificationList.vue?vue&type=script&lang=ts"
export * from "./NotificationList.vue?vue&type=script&lang=ts"

import "./NotificationList.vue?vue&type=style&index=0&id=dcf46392&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcf46392"]])

export default __exports__